module.exports = __webpack_public_path__ + "static/media/sabi_privacy_policy.e55e2278.pdf";